//external libs
import React, { memo, ReactElement, useContext } from "react";

//contexts
import { CheckoutContext, FailedOrderActionPayload } from "@swiggy-private/checkout-core";

//types
import { GetPaymentMethodsResponse } from "@payment-client/interfaces/PaymentApi";
import { CheckoutActionTypes } from "@swiggy-private/checkout-core";
import { OnPayExtraParams } from "@swiggy-private/payment-types";

//components
import PaymentFallbackAlert from "@payment-client/components/payment-fallbacks-alert/PaymentFallbackAlert";
import { PaymentFailedAlert } from "@payment-client/components/payment-failed-alert";
import { PaymentMethodMeta, PaymentMethod, PaymentProgressLoader } from "@swiggy-private/payment-ui";

//hooks
import UsePaymentFallbacks from "@payment-client/hooks/UsePaymentFallbacks";

export interface PaymentFailedAlertProps {
    payAction: (paymentMethodData: PaymentMethod<PaymentMethodMeta>, _extraParams?: OnPayExtraParams) => void;
    selectAction: (method: PaymentMethod<PaymentMethodMeta>) => void;
    paymentGroups: GetPaymentMethodsResponse["paymentGroup"];
    amountToPay: string;
    itemQuantity: number;
    payload: FailedOrderActionPayload;
}

const PaymentFailed = (props: PaymentFailedAlertProps): ReactElement | null => {
    const { fallbackApiMethods, isFallbackApiInProgress } = UsePaymentFallbacks();
    const { checkoutState } = useContext(CheckoutContext);

    if (checkoutState.type !== CheckoutActionTypes.PAYMENT_FAILED) {
        return null;
    }

    if (isFallbackApiInProgress) {
        return <PaymentProgressLoader />;
    }

    if (checkoutState?.payload?.isFallbackApiEnabled && fallbackApiMethods) {
        return (
            <PaymentFallbackAlert
                fallbackApiMethods={fallbackApiMethods}
                payAction={props.payAction}
                payload={props.payload}
                selectAction={props.selectAction}
            />
        );
    }

    return <PaymentFailedAlert {...props} />;
};

export default memo(PaymentFailed);
